import type { FC } from "react";
import { useEffect, useState } from "react";
import type { IAudienceMatrixAPI, ISelectedDomain } from "app/pages/website-analysis/audience-interests/single/types";
import { Header } from "../Header";
import { ActionButtons } from "./ActionButtons";
import { Chart } from "./Chart";
import { getInitialSelectedDomains, getChartData } from "./utils";
import { chosenSites } from "app/common/services/chosenSites";
import { SpinnerLoader } from "pro-features/components/Loaders/src/Spinner";
import styled from "styled-components";

interface ICrossBrowsingOvertimeWrapper {
    rawData: IAudienceMatrixAPI;
    isLoading: boolean;
}

const ChartContainer = styled.div`
    height: 324px;
`;

export const CrossBrowsingOvertimeWrapper: FC<ICrossBrowsingOvertimeWrapper> = (props) => {
    const { rawData, isLoading } = props;
    const sites = chosenSites.get();
    const [selectedDomains, setSelectedDomains] = useState<ISelectedDomain>(getInitialSelectedDomains(sites));
    useEffect(() => {
        const sites = chosenSites.get();
        setSelectedDomains(getInitialSelectedDomains(sites));
    }, [rawData]);

    const chartData = getChartData(rawData, selectedDomains);
    return (
        <>
            <Header
                titleKey={"analysis.audience.interests.overlap.overtime.title"}
                tooltipKey={"analysis.audience.interests.overlap.overtime.tooltip"}
            />
            <ChartContainer>
                {isLoading ? (
                    <SpinnerLoader />
                ) : (
                    <>
                        <ActionButtons
                            selectedDomains={selectedDomains}
                            setSelectedDomains={setSelectedDomains}
                            domains={sites}
                        />
                        <Chart chartData={chartData} />
                    </>
                )}
            </ChartContainer>
        </>
    );
};
